import { render, staticRenderFns } from "./AnswerDialog.vue?vue&type=template&id=3f9a16aa&"
import script from "./AnswerDialog.vue?vue&type=script&lang=js&"
export * from "./AnswerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports